import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
  })

export default formModel
